import { RUSH_PRICE_TIERS, RUSH_PRICE_OVERFLOW_CREDITS_PER_FIVE_MINUTES } from "@kaeliux/shared";
/**
 * Progressive (tax-bracket-style) Dark Matter cost to instantly complete a
 * pending queue item with `remainingSeconds` left on it — see
 * `RUSH_PRICE_TIERS`'s doc comment (`packages/shared/src/constants/premium.ts`)
 * for the bracket schedule. Each bracket only prices the portion of the
 * remaining time that falls within it (like a tax bracket, not a flat
 * lookup): the first 60 minutes remaining cost more per minute than the next
 * 180, which cost more than the next 720, etc.
 *
 * Dark Matter is an integer currency, so the summed fractional cost is
 * rounded UP to the nearest whole credit — a rush is never free, and the
 * player is never charged less than what the bracket math actually produced.
 * `remainingSeconds <= 0` (nothing left to rush) costs 0.
 */
export function calculateRushCost(remainingSeconds) {
    if (remainingSeconds <= 0)
        return 0;
    let remainingMinutes = remainingSeconds / 60;
    let cost = 0;
    for (const tier of RUSH_PRICE_TIERS) {
        const minutesInTier = Math.min(remainingMinutes, tier.minutes);
        cost += (minutesInTier / 5) * tier.creditsPerFiveMinutes;
        remainingMinutes -= minutesInTier;
        if (remainingMinutes <= 0)
            break;
    }
    if (remainingMinutes > 0) {
        cost += (remainingMinutes / 5) * RUSH_PRICE_OVERFLOW_CREDITS_PER_FIVE_MINUTES;
    }
    return Math.max(1, Math.ceil(cost));
}
//# sourceMappingURL=queueRush.js.map